/**
 * Desenvuelve la respuesta de httpClient.
 * Soporta axios-like ({ data: ... }) y respuestas directas.
 */
export function unwrapHttp(res) {
  if (res && typeof res === "object" && "data" in res) return res.data;
  return res;
}